import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

/**
 * A component for counting total results
 */
function Counter({ value, label, category }) {
  const { t } = useTranslation();

  return (
    <div className="results-counter">
      <span className="results-counter__count">{value}</span>
      <span>{label}</span>
      {category && (
        <span>
          &nbsp;{t('styleguide:in')}&nbsp;'<strong>{category}</strong>'
        </span>
      )}
    </div>
  );
}

Counter.propTypes = {
  /**
   * The value
   */
  value: PropTypes.number.isRequired,
  /**
   * The label
   */
  label: PropTypes.string,
  /**
   * The category
   */
  category: PropTypes.string
};

export default Counter;
